import { render } from "./ProductCardSelectable.vue?vue&type=template&id=547fef4e&scoped=true&ts=true"
import script from "./ProductCardSelectable.vue?vue&type=script&lang=ts"
export * from "./ProductCardSelectable.vue?vue&type=script&lang=ts"

import "./ProductCardSelectable.vue?vue&type=style&index=0&id=547fef4e&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547fef4e"]])

export default __exports__